import { type FC } from 'react';

import {
  Thumbnail,
  type ThumbnailProps,
} from '@/microfrontends/listing/shared/containers/listing-cards/containers/desktop/Thumbnail';

import styles from './CardThumbnails.css';

type CardThumbnailsProps = {
  items: (ThumbnailProps & { id: number })[];
};

export const CardThumbnails: FC<CardThumbnailsProps> = props => {
  const { items } = props;

  return (
    <div className={styles['container']}>
      {items.map(thumbnail => (
        <Thumbnail key={thumbnail.id} overlay={thumbnail.overlay} src={thumbnail.src} />
      ))}
    </div>
  );
};
